
import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"

import {ImageModule} from "../../../modules/Image_Module"
import {CustomLinks} from "../../common/utils"


const AuctionNegoItem = (props) => {
    const { glstrapi } = useStaticQuery(graphql`
        query AuctionNegoItemPeopleQuery {
            glstrapi {
                peoples(limit: -1) {
                    id
                    Name
                    Nego_Id
                    Phone_Number
                    URL
                    Image { url alternativeText }
                }
            }
        }
    `)
    const allPeoples = glstrapi?.peoples || [];

    let peopleToRender = [];
    if (props.negotiatorData && props.negotiatorData.length > 0) {
        peopleToRender = props.negotiatorData;
    } else if (props.item) {
        const p = allPeoples.find(x => x.Nego_Id === props.item || x.Nego_Id === String(props.item));
        if (p) peopleToRender = [p];
    }

    return peopleToRender.map((item, index) => (
        <div key={index} className={`contact-person mb-4 ${index > 0 ? "" : "mt-0"}`}>
            <div className="contact-img">
                <Link to={CustomLinks.our_people+CustomLinks.find_team+'/'+item.URL+"/"}>
                    <picture>
                        <ImageModule ImageSrc={item.Image} altText={item.Name+ " - Strettons"}/>
                    </picture>
                </Link>
            </div>
            <div className="contact-info">
                <h3><Link to={CustomLinks.our_people+CustomLinks.find_team+'/'+item.URL+"/"}>{item.Name}</Link></h3>
                <a href={`tel:${item.Phone_Number}`} className="tel">{item.Phone_Number}</a>
            </div>
        </div>
    ));
}

export default AuctionNegoItem;
